import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock, Mail, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import Navbar from "@/components/Navbar";
import { api, formatApiError } from "@/lib/api";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.token) localStorage.setItem("gec_token", data.token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-[#0A0A0C] border border-white/10 focus:border-amber-500 focus:ring-1 focus:ring-amber-500 text-slate-100 placeholder:text-slate-600 rounded-xl pl-11 pr-4 py-3.5 text-sm transition outline-none";

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-slate-100">
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-16">
        <button
          onClick={() => navigate("/")}
          data-testid="admin-login-back-btn"
          className="inline-flex items-center gap-2 text-slate-400 hover:text-amber-400 text-sm mb-6 transition"
        >
          <ArrowLeft className="w-4 h-4" /> Home
        </button>

        <div className="bg-gradient-to-b from-[#18181E] to-[#121216] border border-white/10 rounded-3xl p-8">
          <div className="text-xs uppercase tracking-[0.25em] font-semibold text-amber-400">
            / Admin Access
          </div>
          <h1 className="font-display mt-3 text-3xl font-extrabold uppercase tracking-tight">
            Sign <span className="gold-text">in</span>
          </h1>
          <p className="mt-2 text-sm text-slate-400">
            Access the GETEASY CAR management dashboard.
          </p>

          <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-login-form">
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
              <input
                type="email"
                data-testid="admin-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                className={inputCls}
                required
              />
            </div>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
              <input
                type="password"
                data-testid="admin-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className={inputCls}
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit-btn"
              className="w-full inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-600 disabled:opacity-50 text-black font-extrabold uppercase tracking-wider px-6 py-3.5 rounded-xl shadow-lg shadow-amber-500/20 transition"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
